import { useReadContract } from "wagmi";

const useGetTotalAllowedToMint = (address, abi, userAddress, provider) => {
  return useReadContract({
    address: address,
    abi: abi,
    functionName: "whitelist",
    args: [userAddress],
    provider: provider,
  });
};

export default useGetTotalAllowedToMint;
